var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcDownloadExcel = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "0 0 30 30",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:#fff;}.a{opacity:0;}.b,.f{fill:none;}.b{stroke:#fff;stroke-width:1.1px;}.d{fill:#3f68b5;font-size:9px;font-family:Roboto-Bold, Roboto;font-weight:700;}.e{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-898 -1465)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 30,
  height: 30,
  transform: "translate(898 1465)"
}), /*#__PURE__*/React.createElement("g", {
  className: "b",
  transform: "translate(900 1468)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "e",
  width: 20,
  height: 24,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  className: "f",
  x: 0.55,
  y: 0.55,
  width: 18.9,
  height: 22.9,
  rx: 0.45
})), /*#__PURE__*/React.createElement("rect", {
  className: "c",
  width: 22,
  height: 10,
  rx: 1,
  transform: "translate(905 1471)"
}), /*#__PURE__*/React.createElement("text", {
  className: "d",
  transform: "translate(907.100 1479.4)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "XLS")), /*#__PURE__*/React.createElement("path", {
  className: "c",
  d: "M1,0H3V4H5L1.908,6.716-1,4H1Z",
  transform: "translate(907.999 1483)"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcDownloadExcel);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/ic_download_excel.ba416fada9eeb7316f5f6e06e622ea1e.svg";